var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBtnBorder(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 2,
    viewBox: "0 0 292 2",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 185.505,
    height: 2,
    transform: "matrix(-1 2.96829e-09 -2.5748e-06 -1 238.252 2)",
    fill: "url(#paint0_linear_314_2329)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 0L28 2",
    stroke: "#D65252",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 0L45 2",
    stroke: "#D65252",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0L16 2",
    stroke: "#D65252"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M51 0L51 2",
    stroke: "#D65252"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0L40 2",
    stroke: "#D65252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 0L11 2",
    stroke: "#D65252"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M268 0L268 2",
    stroke: "#D65252"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M257 0L257 2",
    stroke: "#D65252"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M250 0L250 2",
    stroke: "#D65252"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M31 0L31 2",
    stroke: "#D65252"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M291 0L291 2",
    stroke: "#D65252"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 0L2 2",
    stroke: "#D65252",
    strokeWidth: 3
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M281 0L281 2",
    stroke: "#D65252",
    strokeWidth: 3
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M243 0L243 2",
    stroke: "#D65252",
    strokeWidth: 3
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M259 0L259 2",
    stroke: "#D65252",
    strokeWidth: 0.5
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M22 0L22 2",
    stroke: "#D65252",
    strokeWidth: 0.5
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M246 0L246 2",
    stroke: "#D65252",
    strokeWidth: 0.5
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M240 0L240 2",
    stroke: "#D65252",
    strokeWidth: 0.5
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M274 0L274 2",
    stroke: "#D65252",
    strokeWidth: 0.4
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_314_2329",
    x1: 92.7525,
    y1: 0,
    x2: 92.7525,
    y2: 2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DC5A4C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CF4858"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnBorder);
export default __webpack_public_path__ + "static/media/btn-border.61e89c7040dbcbbdb61b70df0c46dca5.svg";
export { ForwardRef as ReactComponent };